<template>
  <div class="company_detai appContainer" v-if="viewPage">
    <div class="title_wrapper">
      <div class="title-company-detail">
        <div class="line"></div>
        <h1>
          {{ companyInfoDetail !== null ? companyInfoDetail.company_name : '' }}
        </h1>
      </div>

      <v-btn color="#42a2ff" rounded class="fav_btn" disabled>
        <img src="@/assets/image/star.svg" alt />
        <span class="fav_btn_info">
          {{
            $t('company-detail.button-add-to-favorite-company', {
              split: '/'
            })
          }}
        </span>
      </v-btn>
    </div>

    <InformationOfCompany
      :companyDetail="companyDetail"
      :companyInfoDetail="companyInfoDetail"
      :isLogVideo="isLogVideo"
    />

    <TabsOfCompany
      v-if="companyDetail !== null"
      :dataJobDescription="dataJobDescription"
      :dataCompanyCareerFromDetail="dataCompanyCareerFromDetail"
      :dataCompanyPrFromDetail="dataCompanyPrFromDetail"
    />

    <v-row>
      <v-col
        cols="12"
        md="4"
        lg="4"
        sm="4"
        v-if="
          companyDetail !== null &&
          companyDetail.detail.d_company !== null &&
          companyDetail.detail !== null &&
          companyDetail.detail.d_company.promotion_img_1 !== null
        "
      >
        <v-card class="mx-auto" max-width="400">
          <v-img
            class="white--text align-end"
            height="auto"
            :src="
              companyDetail !== null &&
              companyDetail.detail !== null &&
              companyDetail.detail.d_company !== null &&
              companyDetail.detail.d_company.promotion_img_1 !== null
                ? companyDetail.detail.d_company.promotion_img_1
                : ''
            "
          ></v-img>
        </v-card>
      </v-col>

      <v-col
        cols="12"
        md="4"
        lg="4"
        sm="4"
        v-if="
          companyDetail !== null &&
          companyDetail.detail !== null &&
          companyDetail.detail.d_company !== null &&
          companyDetail.detail.d_company.promotion_img_2 !== null
        "
      >
        <v-card class="mx-auto" max-width="400">
          <v-img
            class="white--text align-end"
            height="auto"
            :src="
              companyDetail !== null &&
              companyDetail.detail !== null &&
              companyDetail.detail.d_company !== null &&
              companyDetail.detail.d_company.promotion_img_2 !== null
                ? companyDetail.detail.d_company.promotion_img_2
                : ''
            "
          ></v-img>
        </v-card>
      </v-col>

      <v-col
        cols="12"
        md="4"
        lg="4"
        sm="4"
        v-if="
          companyDetail !== null &&
          companyDetail.detail !== null &&
          companyDetail.detail.d_company !== null &&
          companyDetail.detail.d_company.promotion_img_3 !== null
        "
      >
        <v-card class="mx-auto" max-width="400">
          <v-img
            class="white--text align-end"
            height="auto"
            :src="
              companyDetail !== null &&
              companyDetail.detail !== null &&
              companyDetail.detail.d_company !== null &&
              companyDetail.detail.d_company.promotion_img_3 !== null
                ? companyDetail.detail.d_company.promotion_img_3
                : ''
            "
          ></v-img>
        </v-card>
      </v-col>
    </v-row>

    <!-- <div id="interview-scroll" class="interview">
      <h2 class="left-border">
        {{ $t('company-detail.interview-schedule', { split: '/' }) }}
      </h2>

      <v-data-table
        :headers="headers"
        :items="applications"
        class="elevation-1 app_table"
      >
        <template v-slot:[`item.detail`]="{ item }">
          <v-chip color="#E8320D" class="detail_btn" dark disabled>{{
            $t(item.detail, { split: '/' })
          }}</v-chip>
        </template>
      </v-data-table>
    </div> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import InformationOfCompany from '@/components/entry/InformationOfCompany';
import TabsOfCompany from '@/components/entry/TabsOfCompany';
import { getIdFromUrl } from 'vue-youtube';

export default {
  components: {
    InformationOfCompany,
    TabsOfCompany
  },
  data() {
    return {
      viewPage: true,
      detailStatus: true,
      isLogVideo: false
    };
  },

  methods: {
    actionToFavorite(exhibiting_company_id) {
      if (exhibiting_company_id !== null) {
        this.$store.dispatch('actionToFavorite', {
          exhibiting_company_id
        });
      }
    }
  },

  created() {
    const { query } = this.$route;
    if (typeof query.token !== 'undefined') {
      this.detailStatus = false;
      this.$store.dispatch('previewCompany', {
        company_token: query.token
      });
    }
  },

  mounted() {},

  watch: {
    previewCompanyStatus: function (val) {
      return (this.viewPage = val);
    }
  },

  computed: {
    ...mapGetters({
      companyDetail: 'getCompanyDetail',
      previewCompanyStatus: 'getPreviewCompanyStatus',
      dataJobDescription: 'getJobDescriptionFromDetail',
      dataCompanyCareerFromDetail: 'getCompanyCareerFromDetail',
      dataCompanyPrFromDetail: 'getCompanyPrFromDetail',
      companyInfoDetail: 'getCompanyInfoDetail'
    }),

    videoId() {
      if (this.companyDetail && this.companyDetail.detail.d_company) {
        return getIdFromUrl(
          this.companyDetail.detail.d_company.introduction_video
        );
      } else {
        return '';
      }
    }
  }
};
</script>

<style lang="scss">
@import '@/style/common.scss';
@import './company.scss';
</style>
